module.exports = __webpack_public_path__ + "static/img/valueadd10.86c8c1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/valueadd10.png
// module id = FhS+
// module chunks = 1